<template>
  <div class="min-h-screen bg-white">


    <!-- Hero Section -->
    <section class="bg-gradient-to-b from-green-50 to-white py-20 px-4 sm:px-6 lg:px-8">
      <div class="max-w-7xl mx-auto text-center animate__animated animate__fadeInDown" >
        <!-- <p class="text-sm text-gray-600 mb-2">© sorane ore</p> -->
        <h1 class="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
          Dobrodošli u  tvornicu ideja<br>
         <span class="text-green-500">Master<span>Bita</span></span>
        </h1>
        <p class="text-lg text-gray-600 max-w-3xl mx-auto mb-8">
          Ovdje ostvarujemo snove razvijajući sva vaša
          softverska rješenja!
        </p>
        <div class="flex justify-center space-x-4 animate__animated animate__fadeInDown">
          <a href="#contact" class="flex items-center bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg font-medium transition duration-300 shadow-lg hover:shadow-green-200">
    
            KONTAKTIRAJTE NAS
          </a>
          <router-link to="/portfolio" class="flex items-center border border-green-500 text-green-500 hover:bg-green-50 px-6 py-3 rounded-lg font-medium transition duration-300">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2h-1V9z" clip-rule="evenodd" />
            </svg>
            PORTFOLIO
          </router-link>
        </div>
      </div>
    </section>

    <!-- Features Section -->
    <section class="py-16 px-4 sm:px-6 lg:px-8">
      <div class="max-w-7xl mx-auto">
        <div class="grid md:grid-cols-3 gap-8 animate__animated animate__fadeInLeft animate__slow" >
          <!-- Feature 1 -->
          <div class="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition duration-300 border border-green-100 hover:border-green-200">
            <div class="flex items-center mb-4">
              <div class="bg-green-100 p-3 rounded-full mr-4">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 class="text-lg font-bold text-gray-900">Opremljeni za vaš projekt!</h3>
            </div>
            <p class="text-sm text-gray-600">
              Radimo s tehnologijama koje su dokazano efikasne i prilagođene vašim potrebama.
            </p>
          </div>
          
          <!-- Feature 2 -->
          <div class="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition duration-300 border border-green-100 hover:border-green-200">
            <div class="flex items-center mb-4">
              <div class="bg-green-100 p-3 rounded-full mr-4">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
                </svg>
              </div>
              <h3 class="text-lg font-bold text-gray-900">Moderan Dizajn</h3>
            </div>
            <p class="text-sm text-gray-600">
              Dizajniramo prilagođena rješenja za rješavanje vaših jedinstvenih poslovnih izazova.
            </p>
          </div>
          
          <!-- Feature 3 -->
          <div class="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition duration-300 border border-green-100 hover:border-green-200">
            <div class="flex items-center mb-4">
              <div class="bg-green-100 p-3 rounded-full mr-4">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 class="text-lg font-bold text-gray-900">Mi brinemo!</h3>
            </div>
            <p class="text-sm text-gray-600">
              Iako je tehnologija važna, odnos s klijentima nam je na prvom mjestu. Vaše ideje pretvaramo u stvarnost s pažnjom i odgovornošću

            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Services Section -->
    <h2 class="text-2xl font-bold text-center text-gray-500 mb-12">Zadovoljni Klijenti</h2>
    <section class="bg-gradient-to-t from-green-50 to-white border-t border-b  duration-300 border border-green-100 hover:border-green-200">
      <!-- <h2 class="text-2xl font-bold text-center text-gray-800 mb-12 client-h2">Sretni Klijenti</h2> -->
  <Clients />
</section>



    <section class="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50" id="services">
      <div class="max-w-7xl mx-auto">
        <h2 class="text-2xl font-bold text-center text-gray-900 mb-12">Naše Razvojne Usluge</h2>
        <p class="text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12">
          U MasterBitu smo specijalizirani za izradu prilagođenih softverskih rješenja koja odgovaraju vašim jedinstvenim poslovnim potrebama.
        </p>
        
        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-6" >
          <!-- Service 1 -->
          <div class="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition duration-300 border border-green-100 hover:border-green-200 animate__animated animate__fadeInBottomLeft">
            <div class="flex items-center mb-3">
              <i class="fas fa-laptop-code text-green-500 text-xl mr-3"></i>
              <h3 class="text-lg font-bold text-gray-900">Razvoj Prilagođenog Softvera</h3>
            </div>
            <p class="text-sm text-gray-600">
              Stručnost u izgradnji skalabilnih i robusnih prilagođenih softverskih rješenja, od web aplikacija do softvera za poduzeća.
            </p>
          </div>
          
          <!-- Service 2 -->
          <div class="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition duration-300 border border-green-100 hover:border-green-200 animate__animated animate__fadeInLeft">
            <div class="flex items-center mb-3 ">
              <i class="fas fa-mobile-alt text-green-500 text-xl mr-3"></i>
              <h3 class="text-lg font-bold text-gray-900">Razvoj Mobilnih Aplikacija</h3>
            </div>
            <p class="text-sm text-gray-600">
              Dizajniranje i razvoj korisnički prilagođenih mobilnih aplikacija za iOS i Android, poboljšavajući vašu digitalnu prisutnost na mobilnim platformama.
            </p>
          </div>
          
          <!-- Service 3 -->
          <div class="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition duration-300 border border-green-100 hover:border-green-200 animate__animated animate__fadeInBottomRight">
            <div class="flex items-center mb-3">
              <i class="fas fa-globe text-green-500 text-xl mr-3"></i>
              <h3 class="text-lg font-bold text-gray-900">Izrada Web Stranica</h3>
            </div>
            <p class="text-sm text-gray-600">
              Kreiranje modernih i responzivnih web stranica prilagođenih vašim potrebama, s fokusom na korisničko iskustvo i dizajn.
            </p>
          </div>
          
          <!-- Service 4 -->
          <div class="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition duration-300 border border-green-100 hover:border-green-200 animate__animated animate__fadeInBottomLeft">
            <div class="flex items-center mb-3">
              <i class="fas fa-cloud text-green-500 text-xl mr-3"></i>
              <h3 class="text-lg font-bold text-gray-900">Cloud Rješenja</h3>
            </div>
            <p class="text-sm text-gray-600">
              Ponuda rješenja temeljenih na oblaku kako bi se osigurala fleksibilnost, skalabilnost i sigurnost za vaše poslovne operacije.
            </p>
          </div>
          
          <!-- Service 5 -->
          <div class="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition duration-300 border border-green-100 hover:border-green-200 animate__animated animate__fadeInLeft">
            <div class="flex items-center mb-3">
              <i class="fas fa-headset text-green-500 text-xl mr-3"></i>
              <h3 class="text-lg font-bold text-gray-900">Kontinuirana Podrška i Održavanje</h3>
            </div>
            <p class="text-sm text-gray-600">
              Pružanje stalne podrške i održavanja kako bi se osigurala optimalna izvedba vaših softverskih aplikacija.
            </p>
          </div>
          
          <!-- Service 6 -->
          <div class="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition duration-300 border border-green-100 hover:border-green-200 animate__animated animate__fadeInBottomRight">
            <div class="flex items-center mb-3">
              <i class="fas fa-tasks text-green-500 text-xl mr-3"></i>
              <h3 class="text-lg font-bold text-gray-900">Agilno Upravljanje Projektima</h3>
            </div>
            <p class="text-sm text-gray-600">
              Primjena agilnih metodologija za upravljanje i isporuku projekata s visokom učinkovitošću i prilagodljivošću.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Contact Section -->
<section class="py-16 px-4 sm:px-6 lg:px-8 bg-white" id="contact">
  <h2 class="text-3xl font-bold text-gray-900 mb-4">Kontaktirajte nas</h2>
  <p class="text-xl text-gray-600 mb-10">Započnimo digitalnu priču zajedno</p>
  <div class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
    
    <!-- Lijeva strana: tekst, kartice, forma -->
    <div>


      <!-- Kartice (Telefon + Email) -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10">
        <!-- Telefon kartica -->
        <div class="bg-white border border-green-100 rounded-xl p-6 shadow-md hover:shadow-lg transition duration-300 transform hover:-translate-y-1 animate__animated animate__fadeInDown">
          <div class="flex items-center space-x-4">
            <div class="bg-green-100 text-green-600 p-3 rounded-full shadow-inner">
              <i class="fas fa-phone-alt text-lg"></i>
            </div>
            <div>
              <h3 class="text-md font-semibold text-gray-800">Telefon</h3>
              <a href="tel:+385912784111" class="text-green-600 hover:underline mt-1 block">
                +385 91 278 4111
              </a>
            </div>
          </div>
        </div>

        <!-- Email kartica -->
        <div class="bg-white border border-green-100 rounded-xl p-6 shadow-md hover:shadow-lg transition duration-300 transform hover:-translate-y-1 animate__animated animate__fadeInUp">
          <div class="flex items-center space-x-4">
            <div class="bg-green-100 text-green-600 p-3 rounded-full shadow-inner">
              <i class="fas fa-envelope text-lg"></i>
            </div>
            <div>
              <h3 class="text-md font-semibold text-gray-800">E-mail</h3>
              <a href="mailto:info@masterbit.eu" class="text-green-600 hover:underline mt-1 block">
                info@masterbit.eu
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Kontakt forma -->
      <div class="bg-white p-8 rounded-xl shadow-sm border border-green-100 animate__animated animate__fadeInUp">
        <form class="space-y-6" @submit.prevent="sendEmail">
          <div>
            <label for="name" class="block text-sm font-medium text-gray-700 mb-1">Ime</label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <i class="fas fa-user text-gray-400"></i>
              </div>
              <input type="text" id="name" v-model="formData.name" required class="w-full pl-10 px-4 py-2 border border-gray-300 rounded-lg focus:ring-green-500 focus:border-green-500">
            </div>
          </div>

          <div>
            <label for="email" class="block text-sm font-medium text-gray-700 mb-1">E-mail</label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <i class="fas fa-envelope text-gray-400"></i>
              </div>
              <input type="email" id="email" v-model="formData.email" required class="w-full pl-10 px-4 py-2 border border-gray-300 rounded-lg focus:ring-green-500 focus:border-green-500">
            </div>
          </div>

          <div>
            <label for="message" class="block text-sm font-medium text-gray-700 mb-1">Napišite poruku</label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 pt-3 flex items-start pointer-events-none">
                <i class="fas fa-comment text-gray-400"></i>
              </div>
              <textarea id="message" v-model="formData.message" required rows="4" class="w-full pl-10 px-4 py-2 border border-gray-300 rounded-lg focus:ring-green-500 focus:border-green-500"></textarea>
            </div>
          </div>

          <button type="submit" :disabled="loading" class="w-full flex items-center justify-center bg-green-500 hover:bg-green-600 text-white py-3 px-6 rounded-lg font-medium transition duration-300 shadow-lg hover:shadow-green-200">
            <i class="fas fa-paper-plane mr-2"></i>
            {{ loading ? 'SLANJE...' : 'POŠALJI' }}
          </button>
        </form>
      </div>
    </div>

    <!-- Desna strana: slika -->
    <div class="flex justify-center items-center animate__animated animate__fadeInRight">
      <img
        src="@/assets/01.png"
        alt="Kontakt slika"
      />
    </div>
  </div>
</section>

    <Footer />
  </div>
</template>

<script>
import emailjs from '@emailjs/browser';
import Footer from "../components/Footer.vue";
import Clients from "../components/Clients.vue";


export default {
  data() {
    return {
      isMobileMenuOpen: false,
      loading: false,
      formData: {
        name: '',
        subject: '',
        email: '',
        budget: '',
        message: ''
      }
    }
  },
  components: {
    Footer,
    Clients
  },
  methods: {
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    },
    async sendEmail() {
  this.loading = true;
  try {
    // Sačekaj da grecaptcha bude spreman i dohvati token za akciju "submit"
    const token = await new Promise((resolve) => {
      grecaptcha.ready(() => {
        grecaptcha.execute('6LfUeWUrAAAAAA9uhSDi_9CDBexVc_F2IwSAMaGy', { action: 'submit' }).then(resolve);
      });
    });

    if (!token) {
      alert('reCAPTCHA verifikacija nije uspela. Pokušajte ponovo.');
      this.loading = false;
      return;
    }

    // Pošalji email sa tokenom
    await emailjs.send(
      'service_k79vd1e',
      'template_yb2lkxk',
      {
        from_name: this.formData.name,
        from_email: this.formData.email,
        subject: this.formData.subject,
        budget: this.formData.budget,
        message: this.formData.message,
        'g-recaptcha-response': token,  // proslijedi token serveru ako koristiš backend validaciju
      },
      'wM-u_A6v3Zq8evl_Q'
    );

    alert('Poruka uspješno poslana, uskoro čemo vas kontaktirat!');
    this.formData = {
      name: '',
      subject: '',
      email: '',
      budget: '',
      message: ''
    };

  } catch (error) {
    console.error('Error:', error);
    alert('Došlo je do greške prilikom slanja poruke. Pokušajte ponovo');
  } finally {
    this.loading = false;
  }
}

  },
  mounted() {
  const script = document.createElement('script');
  // script.src = `https://www.google.com/recaptcha/enterprise.js?render=6LfUeWUrAAAAAA9uhSDi_9CDBexVc_F2IwSAMaGy`;
  script.src = `https://www.google.com/recaptcha/api.js?render=6LfUeWUrAAAAAA9uhSDi_9CDBexVc_F2IwSAMaGy`;
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);
}

}
</script>

<style scoped>
/* .client-h2{
  margin-top:-2%
  
}
@media (max-width: 480px) {
  .client-h2{
    margin-top:-12%
  }
} */
/* Import Font Awesome */
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css');

/* Cyber green glow effect for interactive elements */
button.bg-green-500:hover, 
button.bg-green-600:hover {
  box-shadow: 0 0 10px rgba(74, 222, 128, 0.7);
}

/* Custom focus styles */
input:focus, textarea:focus {
  box-shadow: 0 0 0 3px rgba(74, 222, 128, 0.3);
  border-color: #10B981;
}
</style>